import * as Yup from "yup";
import { reverseShape } from "Components/shared/helpers/reverse-shape";

export const PickupDateModalSchema = Yup.object().shape(
  reverseShape({
    pickupDateTime: Yup.string().required(),
  }),
);
